import { Post, Product, SocialLinksTargetReach } from "../social";

export enum ProjectType {
  Abnumber = "abnumberChoice",
  StoryLink = "storyLinkChoice",
  SoMeAd = "soMeAdChoice",
}

export interface Project {
  _id: string;
  projectType: ProjectType;
  isLinkoutCampaign: boolean;
  isContentHub: boolean;
  isDailyDeal: boolean;
  abnumber: string;
  name: string;
  owner: {
    id: string;
    name: string;
  };
  client: string;
  description: string;
  urls: string[];
  socialLinks?: SocialLinksTargetReach[];
  socialPosts?: Post[];
  socialProducts?: Product[];
  longforms: string[];
  created: Date;
  updated: Date;
  daterangeFrom: Date;
  daterangeTo: Date;
}
